import { createAction, props } from "@ngrx/store";

export const fillTechSupportAction = createAction("[TechSupport] Fill Tech Support Action", props<{ payload: any }>());

export const addItemToTechSupportAction = createAction(
  "[TechSupport] Add Item To Tech Support Action",
  props<{ payload: any }>()
);

export const removeItemFromTechSupportAction = createAction(
  "[TechSupport] Remove Item From Tech Support Action",
  props<{ payload: any }>()
);

export const updateItemFromTechSupportAction = createAction(
  "[TechSupport] Update Item From Tech Support Action",
  props<{ payload: any }>()
);

export const addFlagsToTechSupportAction = createAction(
  "[TechSupport] Add Flags to Identify Scenario",
  props<{ payload: any }>()
);

export const clearItemsFromTechSupportAction = createAction("[TechSupport] Clear Items From Tech Support Action");
